import { render, staticRenderFns } from "./join-panel.vue?vue&type=template&id=f51da59c"
import script from "./join-panel.vue?vue&type=script&lang=js"
export * from "./join-panel.vue?vue&type=script&lang=js"
import style0 from "./join-panel.vue?vue&type=style&index=0&id=f51da59c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports